import { css } from 'styled-components';
export const reworkCalendarDayNumber = css `
  font: var(--paragraph-font);
  font-weight: 600;
  color: var(--primary-darker);
`;
export const reworkCalendarDayPrice = css `
  font: var(--paragraph-font);
  font-weight: normal;
  font-size: 1.2rem;
  line-height: 1.4rem;
  letter-spacing: 0;
  color: var(--text);
`;
export const reworkCalendarDayHover = css `
  background: transparent;
`;
export const reworkCalendarDayNumberHover = css `
  color: var(--primary-darker);
`;
export const reworkCalendarDayPriceHover = css `
  color: var(--text);
`;
export const reworkCalendarDayHighlighted = css `
  background: white;
`;
export const reworkCalendarDayNumberHighlighted = css `
  color: white;
`;
export const reworkCalendarDayPriceHighlighted = css `
  color: white;
`;
